import styled from 'styled-components'
import { getColor, getSpace } from 'utils/rebrandingUtils'
import { LAYOUT_GRID } from 'utils/constants/layout'

export const FormLinkBody = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => getColor(theme, 'NEUTRAL_800')};
  gap: ${({ theme }) => getSpace(theme, 'S')};
  width: 27.25rem;
  @media only screen and (max-width: ${LAYOUT_GRID.MOBILE.max}) {
    width: fit-content;
  }
`
